import { Paper, PaperProps, styled } from '@mui/material';

const StyledAutocompletePaper = styled(Paper)(({ theme }) => ({
  backgroundColor: 'rgba(37, 37, 37, 1) !important',
  '& li': {
    backgroundColor: ' rgba(37, 37, 37, 1) !important',

    '&:hover': {
      backgroundColor: `${theme.palette.action.hover} !important`
    },

    '&:active .Mui-focus': {
      backgroundColor: 'rgba(204, 204, 0, 0.04) !important'
    },

    '&:disabled': {
      backgroundColor: `${theme.palette.action.disabled} !important`
    }
  },
  '& .MuiAutocomplete-option[aria-selected="true"]': {
    backgroundColor: 'rgba(204, 204, 0, 0.04) !important'
  }
}));

const AutocompletePaper = (props: PaperProps) => <StyledAutocompletePaper elevation={8} {...props} />;

export default AutocompletePaper;
